
import LoleH1 from '~/components/text/lole-h1'
import LoleP from '~/components/text/lole-p'
import SvgWlFavorite from '~/assets/svg/wl-benefits-favorite.svg?inline'
import SvgWlAlarm from '~/assets/svg/wl-benefits-alarm.svg?inline'
import SvgWlLike from '~/assets/svg/wl-benefits-like.svg?inline'

export default {
  name: 'LoleWishlistBenefits',
  components: {
    LoleH1,
    LoleP,
    SvgWlFavorite,
    SvgWlAlarm,
    SvgWlLike,
  },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    wordingErrors: {
      type: Object,
      required: true,
    },
  },
}
